import InstantLuckyDrawRegForm from "./instantLuckyDrawRegForm.container";

export default InstantLuckyDrawRegForm